<template>
    <div v-if="metadata&&metadata.props&&config.props" class="editor-attr-props-wrapper">
        <div v-for="prop of propsList" :key="prop.name" class="editor-attr-props-content">
            <span class="attr-label">
                <PropAdvance v-model="config.propTransformers[prop.name]" :config="config.props[prop.name]" :allFunctionsMap="allFunctionsMap"
                :prop="prop"></PropAdvance>
                <span >{{prop.title}}</span>
                <Poptip v-if="prop.description" placement="top-start" offset="-17" class="prop-help" word-wrap width="200">
                    <Icon type="md-help-circle" />
                    <div slot="content">
                        <span v-html="prop.description"></span>
                    </div>
                </Poptip>
            </span>
            <Prop :prop="prop" @updateVal="updateVal" :config="config" :metadata="metadata" @save="save" :allFunctionsMap="allFunctionsMap"></Prop>
        </div>
    </div>
</template>
<script>

import Vue from 'vue';

import Prop from './prop';
import PropAdvance from './prop-advance';

export default {
    props:[
        "config", "metadata", "allFunctionsMap"
    ],
    components:{
        Prop,PropAdvance
    },
    watch:{
        config:{
            handler(){
                if(this.config&&!this.config.props){
                    this.config.props = {};
                }
                if(this.config&&!this.config.asyncProps){
                    this.config.asyncProps = {};
                }
                if(this.config&&!this.config.propTransformers){
                    this.$set(this.config, 'propTransformers', {});
                }
                if(this.config&&!this.config.events){
                    this.$set(this.config, 'events', []);
                }
                if(this.metadata&&this.metadata.props){
                    for (let i = 0; i < this.metadata.props.length; i++) {
                        const prop = this.metadata.props[i];
                        if(!(prop.name in this.config.props)){
                            // 深拷贝数据,  锁定数据，使其不可改变
                            if(prop.default!==undefined){
                                let defaultValue;
                                if(typeof prop.default === 'object'){
                                    defaultValue = Object.freeze(JSON.parse(JSON.stringify(prop.default)));
                                }else{
                                    defaultValue = prop.default;
                                }
                                Vue.set(this.config.props, prop.name,  defaultValue);
                            } 
                        }
                        if(prop.async){
                            this.config.asyncProps[prop.name] = prop.type.name;
                        }
                    }
                }
            },
            immediate:true
        }
        
    },
    computed: {
        propsList(){
            if( this.metadata && this.metadata.props && this.config.props ){
                return this.metadata.props.filter(it=>{
                    return it.type;
                })
            }else{
                return [];
            }
                
        }
    },
    methods: {
        save(){
            this.$emit("save");
        },
        updateVal(val){
            for (const key in val) {
                 this.config.props[key] = val[key];
            }
           
        }
    },
}
</script>
<style lang="less">
.attr-label {
    padding-right: 8px;
}
.editor-attr-props-content{
    display: flex;
    margin-bottom: 10px;
    .attr-label{
        flex: 0 0 90px;
        display: inline-block;
        line-height: 24px;
    }
    .attr-content{
        flex: 0 0 186px;
    }
    .prop-help{
        padding-left: 3px;
        .ivu-poptip-popper[x-placement^=top] .ivu-poptip-arrow:after{
            border-top-color: #292b31;
        }
        .ivu-poptip-inner{
            background-color: #292b31;
        }
    }
}
</style> 